import { SolutionSourceImageRepositoryItem } from '../types';

export const getSolutionSourceImageRepositoryParams = (
  params: SolutionSourceImageRepositoryItem
) => {
  const serverUrlValue = params.acrServerUrl || params.ecrServerUrl;
  const repoName = params.acrSourceRepoName || params.ecrSourceRepoName;
  delete params.acrServerUrl;
  delete params.ecrServerUrl;
  if (params.containerRepositoryType === '0') {
    return {
      sourceImageRepoName: repoName,
      containerRepositoryType: Number(params.containerRepositoryType),
      serverUrl: serverUrlValue,
      userName: params.sourcePullSecretUserName,
      ImagePullSecret: params.sourcePullSecretPassword,
      AcrClientId: params.acrClientId,
      AcrClientSecret: params.acrClientSecretName,
    };
  }

  return {
    sourceImageRepoName: repoName,
    serverUrl: serverUrlValue,
    containerRepositoryType: Number(params.containerRepositoryType),
    EcrAccesKey: params.ecrAccesKey,
    ecrRegionEndpoint: params.ecrRegionEndpoint,
    ecrSecretKey: params.ecrSecretKey,
  };
};
